module.exports = __webpack_public_path__ + "img/iPhone12ProGraphite.eb49cd62.jpg";